import React, { Component } from 'react';
import Vas from '../../Vas';
import $ from 'jquery';
import CustomerContractDetails from './ContractCard/CustomerContractDetails';
import { ClosePopUps } from 'utils-lib';

class ContractCard extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerContractDetails";
        this.Id = props.match.params.ContractID;
        this.CustomerId = props.match.params.CustomerId;
        this.CustomerName = props.match.params.CustomerName;
    }

    componentDidMount()
    {
        $("#HeaderTitle").html(Vas.Resources.Labels["Contract"]);

        this.LogoClick();
    }

    componentWillMount(){
      this.LogoClick();
    }

    GetCustomerContractDetails(){
      this.LogoClick();

        return (<CustomerContractDetails Id={this.Id} CustomerName={this.CustomerName} CustomerId={this.CustomerId}/>);
    }

    GetView(nameOfView){
      ClosePopUps.close();
      this.LogoClick();
        switch (nameOfView)
        {
            case "Contract":
                this.setState({ CurrentView : "CustomerContractDetails" });
                break;
            default:
                this.setState({ CurrentView: "CustomerContractDetails" });
        }
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
        $('.contractDetailsForm').attr('style', 'border: 1px solid #1d5c87;');

        $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
        $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

        $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
        $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
      }
    }

    render()
    {
      this.LogoClick();

        let content = "";
        switch (this.state.CurrentView)
        {
            case "CustomerContractDetails":
                content = this.GetCustomerContractDetails(this.props.Id);
                break;
            default: content = this.GetCustomerContractDetails(this.props.Id);
        }

        this.LogoClick();

        return (
          <div className={"form contractDetailsForm"} >
            <table className="contractCard">
              <tbody>
                <tr>
                  <td style={{ float:'right' }}><div
                    id={"LoadingIcon"}
                    className={'hide'}></div></td>
                </tr>
                <tr>
                  <td
                    id={"tabContent"}
                    style={{ verticalAlign: 'top', textAlign:'left' }} >{content}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default ContractCard;
